/* GLORY DEPT. — gd-nav.js
   Adds a scrolled state past the hero so the (Horizon) header can deepen
   its background / blur. Non-invasive: only toggles a documentElement attr. */
(function () {
  'use strict';
  var root = document.documentElement;
  var threshold = Math.round(window.innerHeight * 0.6);
  var ticking = false;

  function update() {
    if (window.scrollY > threshold) root.setAttribute('data-gd-scrolled', 'true');
    else root.removeAttribute('data-gd-scrolled');
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { threshold = Math.round(window.innerHeight * 0.6); }, { passive: true });
  update();
})();
